import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import SelectField from './SelectField';
import FormError from './FormError';
import { hasComma, isNotEmail } from '../helpers/validators';
import { formatSaveStatus, prettyKey } from '../helpers/formatters';
// import SelectWithInputField from './SelectWithInputField';
// import { REFERENCE_OPTIONS } from 'constants/users';

let UserForm = ({
  handleSubmit,
  user,
  userTypes,
  saveStatus,
  error,
  showEmail,
  showAclGroup,
}) => (
  <div>
    <h1>Edit User</h1>
    <form onSubmit={handleSubmit}>
      {[
        'id',
        'acl_group_name',
        'is_active',
        'created_at',
        'profile_image',
        'autopay_enabled',
        'promo_code',
      ].map((attr) => (
        <div key={attr}>
          <strong>{prettyKey(attr)}</strong>: {user[attr]}
        </div>
      ))}
      <br />
      {showEmail && (
        <Field component={InputField} name="email" label="Email*" />
      )}
      <Field component={InputField} name="first_name" label="First Name*" />
      <Field component={InputField} name="last_name" label="Last Name*" />
      <Field component={InputField} name="company_name" label="Company Name" />
      <Field component={InputField} name="phone_number" label="Phone Number" />
      <Field component={InputField} name="reference" label="Reference" />
      {/* <Field component={SelectWithInputField} name="reference" label="Reference" options={REFERENCE_OPTIONS} /> */}
      {showAclGroup && (
        <Field
          component={SelectField}
          options={userTypes}
          name="acl_group_name"
          label="Acl Group Name"
        />
      )}
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Save User
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  </div>
);

const validate = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (isNotEmail(values.email)) {
    errors.email = 'Invalid email';
  }
  if (!values.first_name) {
    errors.first_name = 'Required';
  } else if (hasComma(values.first_name)) {
    errors.first_name = 'Comma sign is not allowed';
  }

  if (!values.last_name) {
    errors.last_name = 'Required';
  } else if (hasComma(values.last_name)) {
    errors.last_name = 'Comma sign is not allowed';
  }

  if (values.company_name && hasComma(values.company_name)) {
    errors.company_name = 'Comma sign is not allowed';
  }
  return errors;
};

UserForm = reduxForm({
  form: 'user',
  validate,
})(UserForm);

export default UserForm;
